import styled from 'styled-components';
import { colors } from 'bench-style-constants';

export default styled.button<{ active?: boolean }>`
  box-sizing: border-box;
  background: transparent;
  padding: 2px 8px;
  color: ${colors.water};
  border-radius: 10px;
  outline: 0;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  text-shadow: none;
  border: 1px solid transparent;
  ${({ active }) => active && `border-color: ${colors.water}`};

  &:active {
    box-shadow: none;
  }

  &:hover {
    background: transparent;
    color: ${colors.water};
  }

  &:disabled {
    background: ${colors.cloud};
    border-color: ${colors.cloud};
    &:hover {
      color: ${colors.white};
    }
  }
`;
